import { initializeApp } from "firebase/app"

const configurations = {
  "angus-58d11": {
    app: {
      apiKey: "AIzaSyCMSehobrUnGP3lWVTuqJavQyGfHyNxEYM",
      projectId: "angus-58d11",
      messagingSenderId: "112239835514",
      appId: "1:112239835514:web:9e8f718876f65631a53ec3"
    },
    vapidKey: "BOc4_m7EAmOB-ifWLIm23wjTAwNpGfwmZuf5ZZe575w580EDm95zM1RUXGT8LKwcQsnR2or4wOWZP2jIaFPuWiQ"
  },
  "angus-36007": {
    app: {
      apiKey: "AIzaSyABH0GUfkjaeeMCAWVX7aLoPc8Y6PwN1ZI",
      projectId: "angus-36007",
      messagingSenderId: "857053850422",
      appId: "1:857053850422:web:2149d110b417d706056197"
    },
    vapidKey: "BOqW_6dW9Mh8wpLoDm8cP1JiQuuqNDN7aGM9roTkrFrh24fZeiaxfU1nCzIciPFlKyfcehhl8iwoKE7k_ZAoKIk"
  }
}

export const vapidKey = projectId => configurations[projectId].vapidKey

const initializeFirebaseApp = projectId => initializeApp(configurations[projectId].app)

export default initializeFirebaseApp
